import { envVar } from '@babylon/babylon-env'
import {
  normalizeEnv,
  initDatadogRum,
  setDatadogUser,
  setDatadogLogUser,
  initDatadogLogs,
} from '@telus/datadog'
import { version } from '../package.json'

const applicationId = envVar('DD_APP_ID')
const clientToken = envVar('DD_CLIENT_TOKEN')
const env = normalizeEnv(envVar('ENVIRONMENT'))

export const initDatadog = () => {
  if (env === 'local') return

  if (!clientToken) {
    console.warn('[Datadog] Missing client token.')
    return
  }

  initDatadogLogs({
    clientToken,
    service: 'admin-portal',
    version,
    env,
  })

  if (!applicationId) {
    console.warn('[Datadog] Missing applicationId.')
    return
  }

  initDatadogRum({
    applicationId,
    clientToken,
    service: 'admin-portal',
    version,
    env,
  })
}

export const datadogSetUser = (user: {
  id: string
  userId: string
  roles: Array<{ id: string; name: string }>
}) => {
  setDatadogLogUser(user)
  if (!applicationId) return
  setDatadogUser(user)
}
